import Model from "~/models/_Model";
import Student from "~/models/eschoolplus/registration/Student";
import dayjs from "dayjs";

export default class Update extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/mtss";
  }

  // Set the resource route of the model
  resource() {
    return "updates";
  }

  relations() {
    return {
      student: Student,
    };
  }

  /**
   * Helper Methods
   */

  /**
   * Helper Attributes
   */
  get display_date_column() {
    return dayjs(this.update_date).format("MM/DD/YYYY");
  }
}
